import { PendingJobs } from './views';

export default {
  list: PendingJobs,
  name: 'job-order',
  label: 'Pending Jobs',
  to: '/job-order',
};
